// extracted by mini-css-extract-plugin
export default {"container":"QZO4XAQLOLdxmtUDY8Z6","right":"TVw5HKQxGmQgLkat5Rvg","icon":"_LfIVcPIuaadYRBsOw9v","text":"BQqdH8YbEJv__dGZMPyu"};